define( [
	"../../core"
], function( jQuery ) {

"use strict";

return function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/traversing/var/dir.js
// module id = 2322
// module chunks = 36